(() => {
  if (customElements.get('uws-christmas-pair')) return;
  class ChristmasPair extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.labels = JSON.parse(this.querySelector('[data-uwcp-labels]').textContent);
      this.catalog = JSON.parse(this.querySelector('[data-uwcp-catalog]').textContent);
      this.money = new Intl.NumberFormat(this.dataset.locale || 'de-DE', {style:'currency', currency:this.dataset.currency || 'EUR'});
      this.first = {product:this.catalog[0], options:[this.catalog[0].variants[0].options[0], '']};
      this.second = null;
      this.single = false;
      this.mount = this.querySelector('[data-uwcp-mount]');
      this.mount.innerHTML = `<div class="uwcp-first"></div><div class="uwcp-second"></div>
        <label class="uwcp-single"><input type="checkbox"> <span>${this.t('only_one')}</span></label>
        <p class="uwcp-single-note" hidden>${this.t('single_note')}</p>
        <div class="uwcp-total" aria-live="polite"></div>
        <p class="uwcp-error" role="alert"></p>
        <button type="button" class="uwcp-primary uwcp-submit">${this.t('add')}</button>
        <p class="uwcp-muted">${this.t('cart_note')}</p>
        <dialog class="uwcp-dialog"><button type="button" class="uwcp-close" aria-label="${this.t('close')}">×</button><div class="uwcp-dialog-body"></div></dialog>`;
      this.dialog = this.querySelector('dialog');
      this.dialog.setAttribute('aria-label',this.labels.browse);
      this.dialogBody = this.querySelector('.uwcp-dialog-body');
      this.querySelector('.uwcp-close').addEventListener('click',()=>this.dialog.close());
      this.dialog.addEventListener('click', e=>{ if(e.target===this.dialog){const r=this.dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)this.dialog.close();}});
      this.renderFirst();
      this.renderSecond();
      this.updateTotal();
      this.querySelector('.uwcp-single input').addEventListener('change',e=>{
        this.single=e.target.checked;
        this.querySelector('.uwcp-second').hidden=this.single;
        this.querySelector('.uwcp-single-note').hidden=!this.single;
        this.querySelector('.uwcp-submit').textContent=this.labels[this.single?'add_single':'add'];
        this.querySelector('.uwcp-error').textContent='';
        this.updateTotal();
      });
      this.querySelector('.uwcp-submit').addEventListener('click',()=>this.addToCart());
    }
    t(key) { return this.escape(this.labels[key]); }
    escape(s) { return String(s??'').replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c])); }
    price(cents) {return this.money.format(cents/100);}
    variant(state) {return state?.product.variants.find(v=>v.options.every((o,i)=>o===state.options[i]));}
    soldOut(state) {
      if(!state?.options[0])return false;
      return !state.product.variants.some(v=>v.available&&state.options.every((o,i)=>!o||v.options[i]===o));
    }
    image(state) {return this.variant(state)?.image || state.product.variants.find(v=>v.options[0]===state.options[0])?.image || state.product.images[0]?.src;}
    title(product) {return product.title.replace(/^Weihnachts-Hoodie\s*/i,'');}
    renderFirst() {
      const box=this.querySelector('.uwcp-first');
      box.innerHTML=`<h3><span class="uwcp-step">1</span>${this.t('first')}</h3><div class="uwcp-first-info"><img class="uwcp-first-image" width="100" height="125" alt=""><strong>${this.escape(this.title(this.first.product))}</strong></div><div class="uwcp-first-controls"></div>`;
      this.controls(box.querySelector('.uwcp-first-controls'),this.first,()=>{this.updateFirstImage();this.updateTotal();});
      this.updateFirstImage();
    }
    updateFirstImage() {
      const img=this.querySelector('.uwcp-first-image');img.src=this.image(this.first);img.alt=this.first.product.title+' – '+this.first.options[0];
      const info=this.closest('[id^="ProductInfo"]');
      const filename=src=>new URL(src,location.href).pathname.split('/').pop();
      const gallery=info?.closest('.product')?.querySelector('media-gallery');
      const thumbnail=[...(gallery?.querySelectorAll('button.thumbnail')||[])].find(b=>b.querySelector('img')&&filename(b.querySelector('img').src)===filename(img.src));
      if(thumbnail&&thumbnail.getAttribute('aria-current')!=='true'){
        const x=window.scrollX,y=window.scrollY;thumbnail.click();requestAnimationFrame(()=>window.scrollTo({left:x,top:y,behavior:'instant'}));
      }
      const price=info?.querySelector('.price-item--sale');
      const variant=this.variant(this.first)||this.first.product.variants.find(v=>v.options[0]===this.first.options[0]);
      if(price&&variant)price.textContent=this.price(variant.price);
      window.UWSStockDisplay?.priceBadge(info,this.soldOut(this.first),this.labels.sold_out);
    }
    controls(container,state,onChange) {
      const colors=[...new Set(state.product.variants.map(v=>v.options[0]))];
      const sizes=[...new Set(state.product.variants.map(v=>v.options[1]))];
      const hex={'sand':'#CABFAD','garnet red':'#7D2935','navy':'#010922','army':'#474841','schwarz':'#000000','black':'#000000','chocolate':'#140b07','light pink':'#E4C6D4','weiß':'#FFFFFF','white':'#FFFFFF'};
      container.innerHTML=`<fieldset class="uwcp-colors"><legend>${this.t('color')}: <strong class="uwcp-color-label">${this.escape(state.options[0])}</strong></legend><div class="uwcp-swatches"></div></fieldset><fieldset class="uwcp-sizes"><legend>${this.t('size')}</legend><div class="uwcp-size-buttons"></div></fieldset>`;
      const refresh=()=>{
        container.querySelector('.uwcp-color-label').textContent=state.options[0];
        container.querySelectorAll('[data-color]').forEach(b=>{
          b.setAttribute('aria-pressed',String(b.dataset.color===state.options[0]));
          const out=!state.product.variants.some(v=>v.options[0]===b.dataset.color&&v.available);
          b.classList.toggle('uws-stock-sold',out);
          b.setAttribute('aria-label',this.labels.color+': '+b.dataset.color+(out?' – '+this.labels.sold_out:''));
          b.title=b.dataset.color+(out?' – '+this.labels.sold_out:'');
        });
        container.querySelectorAll('[data-size]').forEach(b=>{
          b.setAttribute('aria-pressed',String(b.dataset.size===state.options[1]));
          b.disabled=!state.product.variants.some(v=>v.options[0]===state.options[0]&&v.options[1]===b.dataset.size&&v.available);
          b.classList.toggle('uws-stock-sold',b.disabled);
          b.setAttribute('aria-label',b.dataset.size+(b.disabled?' – '+this.labels.sold_out:''));
        });
      };
      colors.forEach(color=>{
        const b=document.createElement('button');b.type='button';b.className='uwcp-swatch';b.dataset.color=color;b.title=color;b.setAttribute('aria-label',this.labels.color+': '+color);
        b.style.setProperty('--swatch',hex[color.toLowerCase()]||'#ddd');
        b.addEventListener('click',()=>{state.options[0]=color;if(!this.variant(state)?.available)state.options[1]='';refresh();onChange();});
        container.querySelector('.uwcp-swatches').append(b);
      });
      sizes.forEach(size=>{
        const b=document.createElement('button');b.type='button';b.dataset.size=size;b.textContent=size;
        b.addEventListener('click',()=>{state.options[1]=size;refresh();onChange();});
        container.querySelector('.uwcp-size-buttons').append(b);
      });
      refresh();
    }
    renderSecond() {
      const box=this.querySelector('.uwcp-second');
      box.innerHTML=`<h3><span class="uwcp-step">2</span>${this.t('second')}</h3><p class="uwcp-muted">${this.t('same')}</p>`;
      if(this.second){
        const v=this.variant(this.second);
        box.insertAdjacentHTML('beforeend',`<div class="uwcp-selected"><img src="${this.escape(this.image(this.second))}" alt="${this.escape(this.second.product.title)}" width="100" height="125"><div><strong>${this.escape(this.title(this.second.product))}</strong><p>${this.escape(this.second.options.join(' / '))}</p><span>${this.price(v.price)}</span></div></div>`);
      }
      const b=document.createElement('button');b.type='button';b.className='uwcp-secondary';b.textContent=this.labels[this.second?'change':'choose'];
      b.addEventListener('click',()=>{this.showCatalog();this.dialog.showModal();});box.append(b);
    }
    showCatalog() {
      this.dialog.setAttribute('aria-label',this.labels.browse);
      this.dialogBody.innerHTML=`<p class="uwcp-eyebrow">1 + 1 GRATIS</p><h2>${this.t('browse')}</h2><p>${this.t('same')}</p><div class="uwcp-catalog"></div><p class="uwcp-muted">${this.t('catalog_note')}</p>`;
      for(const product of this.catalog){
        const b=document.createElement('button');b.type='button';b.className='uwcp-design';
        b.innerHTML=`<img src="${this.escape(product.images[0]?.src)}" alt="${this.escape(product.title)}" width="360" height="450"><span><strong>${this.escape(this.title(product))}</strong><small>${this.t('from')} ${this.price(Math.min(...product.variants.map(v=>v.price)))}</small><b>${this.t('details')} →</b></span>`;
        b.addEventListener('click',()=>this.showProduct(product));this.dialogBody.querySelector('.uwcp-catalog').append(b);
      }
    }
    showProduct(product) {
      const state={product,options:this.second?.product.id===product.id?[...this.second.options]:[product.variants[0].options[0],'']};
      this.dialog.setAttribute('aria-label',product.title);
      this.dialogBody.innerHTML=`<button class="uwcp-back" type="button">← ${this.t('back')}</button><div class="uwcp-detail"><div class="uwcp-gallery"><div class="uwcp-hero-wrap"><img class="uwcp-hero" width="800" height="1000" alt=""><button class="uwcp-prev" type="button" aria-label="${this.t('previous')}">‹</button><button class="uwcp-next" type="button" aria-label="${this.t('next')}">›</button></div><div class="uwcp-thumbs"></div></div><div class="uwcp-detail-info"><p class="uwcp-eyebrow">${this.t('second')}</p><h2>${this.escape(this.title(product))}</h2><p class="uwcp-product-price"></p><div class="uwcp-detail-controls"></div><p class="uwcp-modal-error" role="alert"></p><button type="button" class="uwcp-primary uwcp-confirm">${this.t('select')}</button></div></div>`;
      let index=0;
      const setImage=i=>{
        index=(i+product.images.length)%product.images.length;
        const im=product.images[index],hero=this.dialogBody.querySelector('.uwcp-hero');hero.src=im.src;hero.alt=im.alt||product.title;
        this.dialogBody.querySelectorAll('.uwcp-thumbs button').forEach((b,j)=>b.setAttribute('aria-pressed',String(index===j)));
      };
      product.images.forEach((im,i)=>{
        const b=document.createElement('button');b.type='button';b.setAttribute('aria-label',this.labels.image+' '+(i+1));
        b.innerHTML=`<img src="${this.escape(im.src)}" alt="" width="64" height="80" loading="lazy">`;
        b.addEventListener('click',()=>setImage(i));this.dialogBody.querySelector('.uwcp-thumbs').append(b);
      });
      const update=()=>{
        const v=this.variant(state);
        this.dialogBody.querySelector('.uwcp-product-price').textContent=this.labels.regular+': '+this.price(v?.price||Math.min(...product.variants.filter(v=>v.options[0]===state.options[0]).map(v=>v.price)));
        const src=this.image(state)?.split('?')[0];const found=product.images.findIndex(i=>i.src.split('?')[0]===src);if(found>=0)setImage(found);
        this.dialogBody.querySelector('.uwcp-modal-error').textContent='';
        const sold=this.soldOut(state),confirm=this.dialogBody.querySelector('.uwcp-confirm');
        confirm.disabled=!v?.available;confirm.textContent=sold?this.labels.sold_out:this.labels.select;
        if(sold)this.dialogBody.querySelector('.uwcp-product-price').insertAdjacentHTML('beforeend',` <span class="uws-stock-badge">${this.t('sold_out')}</span>`);
      };
      this.controls(this.dialogBody.querySelector('.uwcp-detail-controls'),state,update);
      this.dialogBody.querySelector('.uwcp-back').addEventListener('click',()=>this.showCatalog());
      this.dialogBody.querySelector('.uwcp-prev').addEventListener('click',()=>setImage(index-1));
      this.dialogBody.querySelector('.uwcp-next').addEventListener('click',()=>setImage(index+1));
      this.dialogBody.querySelector('.uwcp-confirm').addEventListener('click',()=>{
        if(!this.variant(state)?.available){this.dialogBody.querySelector('.uwcp-modal-error').textContent=this.labels.single_incomplete;return;}
        this.second={product,options:[...state.options]};this.renderSecond();this.updateTotal();this.dialog.close();
      });
      setImage(0);update();
    }
    totals() {
      const a=this.variant(this.first),b=this.variant(this.second);
      if(!a?.available||(!this.single&&!b?.available))return null;
      return {first:a,second:this.single?null:b,total:this.single?a.price:Math.max(a.price,b.price),saving:this.single?0:Math.min(a.price,b.price),before:this.single?a.price:a.price+b.price};
    }
    updateTotal() {
      const t=this.totals();const el=this.querySelector('.uwcp-total');
      el.innerHTML=t?`<div><span>${this.t('total')}</span><strong>${this.price(t.total)}</strong></div>${t.saving?`<p><s>${this.price(t.before)}</s> <span>${this.t('saving')} ${this.price(t.saving)}</span></p>`:''}<small>${this.t('tax')}</small>`:`<p>${this.t(this.single?'single_incomplete':'pair_hint')}</p>`;
      if(t)this.querySelector('.uwcp-error').textContent='';
      const sold=this.soldOut(this.first)||(!this.single&&this.soldOut(this.second));
      const button=this.querySelector('.uwcp-submit');
      button.disabled=this.busy||!t;
      button.textContent=this.busy?this.labels.adding:sold?this.labels.sold_out:this.labels[this.single?'add_single':'add'];
    }
    async addToCart() {
      if(this.busy)return;
      const t=this.totals();
      const error=this.querySelector('.uwcp-error');
      if(!t){error.textContent=this.labels[this.single?'single_incomplete':'incomplete'];return;}
      const states=this.single?[this.first]:[this.first,this.second];
      const items=states.reduce((all,state)=>{
        const id=this.variant(state).id,match=all.find(item=>item.id===id);
        if(match)match.quantity++;else all.push({id,quantity:1});return all;
      },[]);
      const button=this.querySelector('.uwcp-submit');
      this.busy=true;button.disabled=true;button.textContent=this.labels.adding;error.textContent='';
      const root=window.Shopify?.routes?.root||'/';
      try {
        const response=await fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
        const result=await response.json();
        if(!response.ok||result.status)throw new Error(result.description||this.labels.cart_error);
        window.location.assign(root+'cart');
      } catch(e) {
        error.textContent=e.message||this.labels.cart_error;
        this.busy=false;button.disabled=false;button.textContent=this.labels[this.single?'add_single':'add'];
      }
    }
  }
  customElements.define('uws-christmas-pair',ChristmasPair);
})();
